// @flow

import { isProd } from '../util/config';

const API_HOST = isProd ? 'https://api.thehiringengine.com' : 'https://local.apply.expeditiondata.com:8000';

const sendRequest = (uri: string, method: string, options: Object = {}) => {
  const headers = method === 'POST' ? {
    'Content-Type': 'application/json',
  } : {};
  const opts = Object.assign({}, options, {
    method,
    headers: Object.assign({}, headers, {
      Accept: 'application/json',
    }),
  });
  return fetch(uri, opts);
};

export const Api = {
  post: (uri: string, body: ?any) => sendRequest(`${API_HOST}/api${uri}`, 'POST', {
    body: JSON.stringify(body),
  }),
  get: (uri: string) => sendRequest(`${API_HOST}/api${uri}`, 'GET'),
};
